import React, { useState, useEffect } from "react";
import Header from "../components/landing/Header";
import HeroSection from "../components/landing/HeroSection";
import HowItWorks from "../components/landing/HowItWorks";
import Features from "../components/landing/Features";
import Customers from "../components/landing/Customers";
import VendorSection from "../components/landing/VendorSection";
import TrustSection from "../components/landing/TrustSection";
import CTASection from "../components/landing/CTASection";
import Footer from "../components/landing/Footer";

// Asset imports for preloading
import TrackMonitor from "../assets/TrackMonitor.jpg";
import Garage from "../assets/Garage.jpg";
import VehicleFront from "../assets/VehicleFront.jpg";
import CarNavigating from "../assets/CarNavigating.jpg";

function Home() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // ✅ Preload images
  useEffect(() => {
    const images = [VehicleFront, TrackMonitor, Garage, CarNavigating];
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      // Offset by header height
      const y = section.getBoundingClientRect().top + window.scrollY - 64; 
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen overflow-x-hidden">
      <Header
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        handleScroll={handleScroll}
      />
      
      <HeroSection handleScroll={handleScroll} />
      
      <HowItWorks />
      
      <Features />
      
      <Customers handleScroll={handleScroll} />
      
      <VendorSection />
      
      <TrustSection />
      
      <CTASection />
      
      <Footer />
    </div>
  );
}

export default Home;